var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{class:'mobile-display-none text-center vh fixed '+ _vm.side,attrs:{"cols":"2","no-gutters":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }